import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/pro-solid-svg-icons/faAngleRight';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons/faCircleCheck';

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import HelpArticleLink from '../../../../../components/help-article-link';
import { linkIDs } from '../../../../../services/link-service/links';
import { AssistPanel } from '../assist-panel';
import { messages } from './messages';
import styles from './styles.module.less';

export const FeedbackPanel = () => {
  return (
    <AssistPanel header={<Text textType={TextType.H3} value={messages.panelHeader} />} icon={faCircleCheck}>
      <Text className={styles['content-info']} textType={TextType.Paragraph} value={messages.panelInformation} />
      <FlexRow className={styles['content-button-panel']}>
        <HelpArticleLink articleId={linkIDs.InventoryInShipstation} className={styles['learn-more-btn']}>
          <FormattedMessage {...messages.learnMore} />
        </HelpArticleLink>
        <Button className={styles['feedback-btn']} href='https://form.jotform.com/242334908080151' theme='link'>
          <FormattedMessage {...messages.giveFeedback} />
          <FontAwesomeIcon icon={faAngleRight} />
        </Button>
      </FlexRow>
    </AssistPanel>
  );
};
